/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import IndexedList from '../../support/shared/IndexedList';
import Imm from '../../support/ImmutableHelpers';
import createFormElement from './FormElements/helpers/createFormElement';

import { FormField } from './FormElements/types/FormField';
import {
  PaymentMethodType,
  SignupFormDefinition,
} from '../../types/shared/FormDefinition';
import { Group } from '../../types/shared/Group';
import { RGBColor } from '../../types/shared/Account';

const IS_INITIALIZED = {};

/** TODO: Extend this class from FormModel to remove duplicate fields? */
class SignupFormModel {
  id: string = undefined as any;
  name: string = undefined as any;
  enabled: boolean = undefined as any;
  fields: IndexedList<FormField> = undefined as any;
  groups: Array<Group> = undefined as any;
  display_price: boolean = undefined as any;
  allow_renewal: boolean | undefined = undefined as any;
  payment_on_submit: PaymentMethodType | null | undefined;
  feeOption: string | undefined = undefined as any;
  feeValue: number = undefined as any;
  show_preamble: boolean | undefined = undefined as any;
  preamble_content: string = undefined as any;
  post_submit_content: string = undefined as any;
  send_post_submit_email: boolean | undefined = undefined as any;
  post_submit_email_subject: string | null | undefined;
  post_submit_email_content: string | null | undefined;
  admin_notify: boolean | undefined = undefined as any;
  filter_fields: Array<string> | undefined = undefined as any;
  created_at: string | null | undefined;
  modified_at: string | null | undefined;
  backgroundColor: RGBColor | undefined;

  // TODO: Validate definition?
  constructor(
    definition: SignupFormDefinition,
    isInitialized?: ObjectOf<any> | null | undefined,
  ) {
    if (isInitialized === IS_INITIALIZED) {
      Object.assign(this, definition);
      return;
    }
    this.id = definition.id;
    this.name = definition.name;
    this.enabled = definition.enabled ?? true;
    let fields = [];
    for (let field of definition.fields) {
      let formElement = createFormElement(definition.id, field.type, field);
      if (formElement) {
        fields.push(formElement);
      }
    }

    this.fields = new IndexedList(fields);
    this.groups = definition.groups ?? [];
    this.allow_renewal = definition.allow_renewal;
    this.display_price = definition.display_price ?? false;
    this.payment_on_submit = definition.payment_on_submit;
    this.feeOption = definition.feeOption;
    this.feeValue = definition.feeValue ?? 0;
    this.show_preamble = definition.show_preamble;
    this.preamble_content = definition.preamble_content ?? '';
    this.post_submit_content = definition.post_submit_content ?? '';
    this.send_post_submit_email = definition.send_post_submit_email;
    this.post_submit_email_subject = definition.post_submit_email_subject;
    this.post_submit_email_content = definition.post_submit_email_content;
    this.admin_notify = definition.admin_notify;
    this.filter_fields = definition.filter_fields;
    this.created_at = definition.created_at
      ? new Date(definition.created_at).toJSON()
      : null;
    this.modified_at = definition.modified_at
      ? new Date(definition.modified_at).toJSON()
      : null;
    this.backgroundColor = definition.backgroundColor;
  }

  update(updates: { [key: string]: unknown }) {
    // TODO: This is hacky shit. Let's fix this.
    let result = Imm.setProperties(this as any, updates);
    if (!(result instanceof SignupFormModel)) {
      result = new SignupFormModel(result, IS_INITIALIZED);
    }
    return result as SignupFormModel;
  }

  toJSON(): SignupFormDefinition {
    return {
      id: this.id,
      name: this.name,
      enabled: this.enabled,
      fields: this.fields.mapToArray((field: any) => field.toJSON()),
      groups: this.groups,
      allow_renewal: this.allow_renewal,
      display_price: this.display_price,
      payment_on_submit: this.payment_on_submit,
      feeOption: this.feeOption,
      feeValue: this.feeValue,
      show_preamble: this.show_preamble,
      preamble_content: this.preamble_content,
      post_submit_content: this.post_submit_content,
      send_post_submit_email: this.send_post_submit_email,
      post_submit_email_subject: this.post_submit_email_subject,
      post_submit_email_content: this.post_submit_email_content,
      admin_notify: this.admin_notify,
      filter_fields: this.filter_fields,
      created_at: this.created_at ? this.created_at : undefined,
      modified_at: this.modified_at ? this.modified_at : undefined,
      backgroundColor: this.backgroundColor,
    };
  }
}

export default SignupFormModel;
